export default __webpack_public_path__ + "static/guy1final2-9eb326dc0b0a2dd2510f8133836cd07f.png";